import { useParams, Link, Navigate } from "react-router-dom";
import { Check, ArrowLeft } from "lucide-react";
import { PROGRAMS } from "../data/site";
import { Reveal, Label, BookButton } from "../components/ui-kit";

export default function ProgramDetail() {
  const { slug } = useParams();
  const p = PROGRAMS.find((x) => x.slug === slug);
  if (!p) return <Navigate to="/programs" replace />;
  const idx = PROGRAMS.findIndex((x) => x.slug === slug);
  const next = PROGRAMS[(idx + 1) % PROGRAMS.length];

  return (
    <>
      <section className="relative h-[60vh] min-h-[420px] grain overflow-hidden" data-testid="program-detail-hero">
        <img src={p.image} alt={p.title} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-black/40" />
        <div className="relative z-10 h-full max-w-7xl mx-auto px-6 md:px-12 flex flex-col justify-end pb-14">
          <Link to="/programs" className="inline-flex items-center gap-2 text-lightgrey hover:text-gold transition mb-6 w-fit" data-testid="back-programs"><ArrowLeft size={18} /> All Programs</Link>
          <Label>{p.tagline}</Label>
          <h1 className="font-display uppercase text-white text-5xl md:text-8xl leading-[0.9] mt-4">{p.title}</h1>
        </div>
      </section>

      <section className="bg-black py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-[1.2fr_1fr] gap-14">
          <Reveal>
            <p className="text-2xl md:text-3xl text-white font-display leading-snug">{p.blurb}</p>
            <p className="mt-6 text-lightgrey text-lg">Every session is fully coached and scaled to your ability. You'll always know exactly what to do, why you're doing it, and how to do it safely. This is fitness that fits real, busy lives — and a room full of people who want to see you win.</p>
            <div className="mt-10"><BookButton testid="detail-book">Start With a Free Intro</BookButton></div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="rounded-3xl border border-white/10 bg-charcoal p-8">
              <h3 className="font-display text-2xl text-white uppercase mb-6">What's included</h3>
              <ul className="space-y-4">
                {p.points.map((pt) => (
                  <li key={pt} className="flex gap-3 text-lightgrey">
                    <span className="w-6 h-6 rounded-full bg-gold flex items-center justify-center shrink-0 mt-0.5"><Check size={14} className="text-black" /></span>{pt}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="bg-charcoal py-16">
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-wrap justify-between items-center gap-6">
          <div>
            <p className="text-white/40 text-sm uppercase tracking-widest">Up next</p>
            <Link to={`/programs/${next.slug}`} className="font-display text-3xl md:text-4xl text-white uppercase hover:text-gold transition" data-testid="next-program">{next.title} →</Link>
          </div>
          <BookButton testid="detail-book-2">Book Your Free Intro</BookButton>
        </div>
      </section>
    </>
  );
}
